export default __webpack_public_path__ + "static/media/file-type-csv-icon.a4676443.svg";